// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- DARK THEME MAPPING FOR BOTTOM PANEL --- */

.bottom-panel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%; 
  width: 100%;
  /* Use variable for border */
  border-top: 1px solid var(--border-color); 
  box-sizing: border-box;
  overflow: hidden;
  background-color: var(--bg-panel); /* Added this */
}

/* Toolbar at the top of bottom panel */
.bottom-toolbar {
  display: flex;
  gap: 6px;
  padding: 4px 8px;
  /* DARK MODE COLORS */
  background-color: #1a1a1a; 
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  align-items: center;
}

.bottom-toolbar button {
  padding: 2px 6px;
  cursor: pointer;
  border-radius: 4px;
  /* DARK MODE BUTTONS */
  border: 1px solid #444;
  background-color: #2a2a2a;
  color: var(--text-main);
  transition: background 0.2s;
}

.bottom-toolbar button:hover {
  background-color: #3d5afe; /* Accent color on hover */
  color: #fff;
  border-color: #3d5afe;
}

/* Bottom content takes remaining height */
.bottom-content {
  flex: 1 1;
  overflow: auto;
  padding: 6px;
  /* CHANGE THIS FROM #fff TO DARK */
  background-color: var(--bg-central); 
  color: var(--text-main);
  min-height: 0;
}

/* --- MAXIMIZED STATE --- */
.bottom-panel-wrapper.maximized {
  position: fixed !important;
  top: 40px !important;    
  bottom: 24px !important; 
  left: 0 !important;
  right: 0 !important;
  height: auto !important; 
  width: auto !important;
  z-index: 5000 !important; 
  
  /* CHANGE THIS FROM white TO DARK */
  background: var(--bg-app) !important; 
  border-top: 3px solid var(--accent);
  box-shadow: 0 -10px 30px rgba(0,0,0,0.5); 
  box-sizing: border-box;
}

.bottom-content {
  flex: 1 1;
  overflow: auto; /* This creates the scrollbars if the SVG is bigger */
  background-color: var(--bg-app);
  position: relative;
  min-height: 0; 
}

/* Optional: Style the scrollbars to match the dark theme */
.bottom-content::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.bottom-content::-webkit-scrollbar-thumb {
  background: #333;
  border: 2px solid var(--bg-app);
  border-radius: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Bottom/Bottom1.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC,EAAE,eAAe;AACpD;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,WAAW;EACX,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,SAAW;EACX,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,uBAAuB;EACvB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;;EAExB,mCAAmC;EACnC,oCAAoC;EACpC,mCAAmC;EACnC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc,EAAE,qDAAqD;EACrE,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":["/* --- DARK THEME MAPPING FOR BOTTOM PANEL --- */\n\n.bottom-panel-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%; \n  width: 100%;\n  /* Use variable for border */\n  border-top: 1px solid var(--border-color); \n  box-sizing: border-box;\n  overflow: hidden;\n  background-color: var(--bg-panel); /* Added this */\n}\n\n/* Toolbar at the top of bottom panel */\n.bottom-toolbar {\n  display: flex;\n  gap: 6px;\n  padding: 4px 8px;\n  /* DARK MODE COLORS */\n  background-color: #1a1a1a; \n  border-bottom: 1px solid var(--border-color);\n  flex-shrink: 0;\n  align-items: center;\n}\n\n.bottom-toolbar button {\n  padding: 2px 6px;\n  cursor: pointer;\n  border-radius: 4px;\n  /* DARK MODE BUTTONS */\n  border: 1px solid #444;\n  background-color: #2a2a2a;\n  color: var(--text-main);\n  transition: background 0.2s;\n}\n\n.bottom-toolbar button:hover {\n  background-color: #3d5afe; /* Accent color on hover */\n  color: #fff;\n  border-color: #3d5afe;\n}\n\n/* Bottom content takes remaining height */\n.bottom-content {\n  flex: 1 1 0;\n  overflow: auto;\n  padding: 6px;\n  /* CHANGE THIS FROM #fff TO DARK */\n  background-color: var(--bg-central); \n  color: var(--text-main);\n  min-height: 0;\n}\n\n/* --- MAXIMIZED STATE --- */\n.bottom-panel-wrapper.maximized {\n  position: fixed !important;\n  top: 40px !important;    \n  bottom: 24px !important; \n  left: 0 !important;\n  right: 0 !important;\n  height: auto !important; \n  width: auto !important;\n  z-index: 5000 !important; \n  \n  /* CHANGE THIS FROM white TO DARK */\n  background: var(--bg-app) !important; \n  border-top: 3px solid var(--accent);\n  box-shadow: 0 -10px 30px rgba(0,0,0,0.5); \n  box-sizing: border-box;\n}\n\n.bottom-content {\n  flex: 1;\n  overflow: auto; /* This creates the scrollbars if the SVG is bigger */\n  background-color: var(--bg-app);\n  position: relative;\n  min-height: 0; \n}\n\n/* Optional: Style the scrollbars to match the dark theme */\n.bottom-content::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n.bottom-content::-webkit-scrollbar-thumb {\n  background: #333;\n  border: 2px solid var(--bg-app);\n  border-radius: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
